import { REPORT_HEIGHT, REPORT_WIDTH } from '../ReportConstant';

export default () => {

    return `<style>
        @page {
            size: ${REPORT_WIDTH}px ${REPORT_HEIGHT}px;
            margin: 90px 0 90px 0;
            @top-left {
                content: element(header-element);
            }
            
            @bottom-left {
                content: element(footer-element);
            }
        }
        .page-break {
            page-break-before: always;
        }
        html, body, p {
            padding: 0;
            margin: 0;
        }
        html,
        body {
            height: 100%;
            font-size: 12px;
            color: #38424a;
            font-family: sans-serif;
        }
        #header {
            position: running(header-element);
        }
        #footer {
            position: running(footer-element);
            color: #666666;
        }
        #header, .body-content, #footer {
            padding-left: 60px;
            padding-right: 60px;   
        }
        #pagenumber:before {
            content: counter(page);
        }
        .section-header {
            font-weight: bold;
            color: #FFFFFF;
            padding: 9px 5px;
            background-color: #1F323E;
            margin-bottom: 15px;
            font-size: 14px;
        }
        .titles-section {
            margin-top: 20px;
        }
        .titles-section table tr td, .titles-section table tr th {
            padding-right: 15px;
            padding-bottom: 8px;
        }
        .titles-section table tr td:last-child, .titles-section table tr th:last-child {
            padding-right: 0;
        }
        .grid-layout table {
            -fs-table-paginate: paginate;
        }
        .grid-layout table td, .grid-layout table th {
            min-width: 100px;
        }
        .property-label {
            font-weight: 400;
            color: #000000;
        }
        .disclaimer-section p {
            margin: 0;
            padding-bottom: 20px;
        }
        .page-break-avoid {
            page-break-inside: avoid;
        }
    </style>
`
};
